
import Navbar from '../../components/feature/Navbar';
import Hero from '../../components/feature/Hero';
import Services from '../../components/feature/Services';
import Pricing from '../../components/feature/Pricing';
import AdditionalServices from '../../components/feature/AdditionalServices';
import WhyWebloom from '../../components/feature/WhyWebloom';
import Contact from '../../components/feature/Contact';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <Pricing />
      <WhyWebloom />
      <AdditionalServices />
      <Contact />
      <Footer />
    </div>
  );
}
